<script>
  // Props
  let {
    xScale,
    margin,
    height,
    width,
    format = null,
    filterFunc = () => true
  } = $props();

  // Conditionally apply the formatter if provided
  const formatter = format
    ? (tick) => format(tick) // Use the provided formatter
    : (tick) => tick; // Default: no formatting

  // Function to filter the ticks based on the provided filter function
  // This is initialized once and won't react to changes in `xScale` or `filterFunc`.
  // If you need to respond to user interactions (e.g., show only 1, 3, or 6 months),
  // e.g via a dropdown menu. consider using a reactive declaration or `$derived`
  // to recompute `filteredDomain`.
  let filteredDomain = xScale ? xScale.domain().filter(filterFunc) : [];
</script>

{#if xScale}
  <g transform="translate(0,{height - margin.bottom})">
    <!-- Axis line -->
    <line stroke="currentColor" x1={margin.left} x2={width - margin.right} />

    <!-- All ticks -->
    {#each xScale.domain() as tick}
      <line
        stroke="currentColor"
        x1={xScale(tick) + xScale.bandwidth() / 2}
        x2={xScale(tick) + xScale.bandwidth() / 2}
        y1={0}
        y2={6} />
    {/each}

    <!-- Filtered labels -->
    {#each filteredDomain as tick}
      <text
        font-size="12px"
        fill="currentColor"
        text-anchor="middle"
        x={xScale(tick) + xScale.bandwidth() / 2}
        y={16}>
        {formatter(tick)}
      </text>
    {/each}
  </g>
{/if}
